import compose from 'react-hooks-compose'

import { useLogic } from './useLogic'
import { Presenter } from './presenter'
// export { Presenter as AuthStep } from './presenter'

export const AuthStep = compose(props => ({
	useLogic: () => useLogic(props),
}))(Presenter)
